import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import { Button, Container } from '@mui/material';
import { logout } from '../../slices/auth';
import { useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo.png'


function DrawerAppBar(props) {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleLogout = () =>{
    dispatch(logout())
    .then(()=>{
      navigate('/login')
    })
  }

  return (
    <Box sx={{ display: 'flex'}}>
      <CssBaseline />
      <AppBar component="nav" sx={{background: '#B6E2E8', color: '#000', py: 3, boxShadow:'none'}}>
      <Container maxWidth="md">
      <Box sx={{display:'flex', justifyContent:'start'}} >
        <Link to='/'>
            <img src={Logo} alt='logo'></img>
        </Link>
        </Box>
      </Container>
      </AppBar>
    </Box>
  );
}

export default DrawerAppBar;